import React from "react";
import { DPRestrictedPage } from "Components/DP";
import { Grid, Typography } from "@material-ui/core";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import { PageNotFound } from "..";
import { HelpText } from "Components/Shared/HelpText/HelpText";
import { DownloadTemplate } from "./DownloadTemplate/DownloadTemplate";
import { DisbursementsFilesTable } from "./DisbursementsFilesTable/DisbursementsFilesTable";
import { FileUploadButton } from "./FileUploadButton/FileUploadButton";
import { DisbursementTimingExplanation } from "Components/Shared/DisbursementTimingExplanation/DisbursementTimingExplanation";
import useStyles from "./styles";

const DisbursementsFileUpload = () => {
  const classes = useStyles();
  const { offCyclePaymentOptions, permissions } = usePartnerConfig();
  const hideReport =
    !offCyclePaymentOptions.enableBatchOffCycleDisbursements ||
    !permissions.canListBatchDisbursements;

  if (hideReport) {
    return <PageNotFound />;
  }

  return (
    <DPRestrictedPage
      title="Off-Cycle Disbursements Report"
      permissionKey="canViewReports"
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h2">File Upload</Typography>
        </Grid>
        <Grid container spacing={2} item alignItems="flex-start">
          <Grid item xs={9}>
            <HelpText disableTypography>
              <Typography>
                <b>What is the Batch Off-Cycle Disbursements?</b> Use the
                template to upload information of the individual(s) to whom you
                would like to disburse money using "Same Day ACH". Each
                disbursement is represented as a row in the file.
              </Typography>
              <DisbursementTimingExplanation />
            </HelpText>
          </Grid>
          <Grid item className={classes.downloadTemplateButton}>
            <DownloadTemplate />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <FileUploadButton />
          <DisbursementsFilesTable />
        </Grid>
      </Grid>
    </DPRestrictedPage>
  );
};

export default DisbursementsFileUpload;
